import React from 'react';
import cx from 'classnames';
import Box from '@/shared/ui/Box';
import Title from '@/shared/ui/Title';

type CardProps = {
  children: React.ReactNode;
  title: string;
  className?: string;
  actions?: React.ReactNode;
}

const Card = (props: CardProps) => {
  const {
    className = '',
    children,
    title,
    actions = null,
  } = props;

  return (
    <Box className={cx(className, 'relative')}>
      <div className="flex items-center justify-between min-h-[30px]">
        <Title>{title}</Title>
        {actions ? actions : null}
      </div>

      {children}
    </Box>
  );
}

export default Card;
